module.exports = __webpack_public_path__ + "img/icon_player_w200_h200.619797c0.png";